import React from "react";

const SpinnerIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="18"
        width="18"
        viewBox="0 0 960 960"
        fill="currentColor"
    >
        <path d="M480 880q-82 0-155-31.5t-127.5-86Q143 708 111.5 635T80 480q0-83 31.5-155.5t86-127Q252 143 325 111.5T480 80q17 0 28.5 11.5T520 120q0 17-11.5 28.5T480 160q-133 0-226.5 93.5T160 480q0 133 93.5 226.5T480 800q133 0 226.5-93.5T800 480q0-17 11.5-28.5T840 440q17 0 28.5 11.5T880 480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480 880Z" />
    </svg>
);

export default SpinnerIcon;
